import { Injectable } from '@angular/core';
import { DocumentModel } from '@fi-app/document/document.model';

export type TOnPreviewGeneratedFn = (documentId: number, previewHTML: string) => Promise<void>;

type TGeneratePreviewFn = (
    doc: DocumentModel,
    languageId: number,
    onPreviewGeneratedFn: TOnPreviewGeneratedFn,
) => Promise<void>;

@Injectable()
export class DocumentGeneratePreviewService {
    private generatePreviewFn: TGeneratePreviewFn;

    registerGeneratePreview(fn: TGeneratePreviewFn) {
        this.generatePreviewFn = fn;
    }

    generateDocumentPreviewImage(doc: DocumentModel, languageId: number, fn?: TOnPreviewGeneratedFn) {
        if (!this.generatePreviewFn) return Promise.reject();
        return this.generatePreviewFn(doc, languageId, fn);
    }
}
